import { AmenityKindEnum } from "redmond/apis/tysons/vacation-rentals";

export const MOST_POPULAR_AMENITIES: AmenityKindEnum[] = [
  AmenityKindEnum.Kitchen,
  AmenityKindEnum.AirConditioning,
  AmenityKindEnum.Wifi,
  AmenityKindEnum.Washer,
  AmenityKindEnum.CoffeeMaker,
  // AmenityKindEnum.Dishwasher,
  AmenityKindEnum.Parking,
  AmenityKindEnum.Dryer,
  AmenityKindEnum.Pool,
  AmenityKindEnum.OutdoorSpace,
  AmenityKindEnum.BarbecueGrill,
  AmenityKindEnum.HotTub,
  AmenityKindEnum.Gym,
  AmenityKindEnum.Accessibility,
  AmenityKindEnum.PetFriendly,
  AmenityKindEnum.FreeParking,
  // AmenityKindEnum.FirePit,
  // AmenityKindEnum.Sauna,
];

export const VR_NOT_AVAILABLE_MODAL_TITLE =
  "This vacation rental is not available.";

export const RETURN_TO_SEARCH_MODAL_SECONDARY_TEXT =
  "Return to the search page for more vacation rentals.";

export const RETURN_TO_SEARCH_MODAL_PRIMARY_BUTTON_TEXT = "Return to search";
